module.exports = __webpack_public_path__ + "img/display-icon4.aae7f0cd.png";